var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrupoEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4823 -2780)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4823 2780)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4844.502 -2803.501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.937,37.431H50.593V35.086a.585.585,0,0,0-.585-.585H30.087a.585.585,0,0,0-.585.585V49.149a.585.585,0,0,0,.585.585h2.344v2.344a.585.585,0,0,0,.585.585h19.92a.585.585,0,0,0,.585-.585V38.016A.585.585,0,0,0,52.937,37.431Zm-.585,11.857L47.268,45.1l5.084-4.275Zm0-9.994L43.8,46.484a1.364,1.364,0,0,1-1.647,0L33.6,39.292V38.6h18.75ZM33.6,40.823,38.686,45.1,33.6,49.288Zm-2.93,7.741V35.672h18.75v1.759H33.017a.585.585,0,0,0-.585.585V48.563Zm2.93,2.93v-.687l6-4.941,1.8,1.516a2.509,2.509,0,0,0,3.153,0l1.8-1.516,6,4.941v.687Z",
    fill: "#1d252c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupoEmail);
export default __webpack_public_path__ + "static/media/grupo_email.a96cfa33e108deda5f709f98639a2bb5.svg";
export { ForwardRef as ReactComponent };